<template>
<div>
    <v-card v-if="loaded">
        <v-card-text>
            <v-row>
                <v-col cols="12" sm="6" md="8">
                    <div class="headline font-weight-light">
                        Schedules
                    </div>
                </v-col>

                <v-col cols="12" sm="6" md="4">
                    <div class="text-right">
                        <v-btn depressed class="accent" @click="$router.push('/admin-schedules/add?ct='+center)">New schedule</v-btn>
                    </div>
                </v-col>
            </v-row>
        </v-card-text>

        <v-data-table
            :headers="headers"
            :items="items"
            :items-per-page="25"
            no-data-text="No schedules registered.">
            <template v-slot:item.name="{ item }">
                <div class="d-flex align-center">
                    <GroupAvatar :photo="item.photo" size="22px" />
                    <div class="ml-2">{{item.name}}</div>
                </div>
            </template>

            <template v-slot:item.action="{ item }">
                <v-icon small class="mr-4" color="grey">fa-pen</v-icon>
                <!-- <v-icon small color="grey" class="mr-4">fa-trash</v-icon> -->
            </template>
        </v-data-table>
    </v-card>

    <SendingLoader v-else/>
</div>
</template>

<script>
import _ from 'lodash'
import Schedules from '@/firebase/schedules'

export default {
    data: () => ({
        loaded: false,
        items: [],
        headers: [
            {
                text: 'Day',
                align: 'left',
                value: 'day',
            },
            {   text: 'Hour', 
                value: 'hour' 
            },
            { 
                text: 'Actions', 
                align: 'right',
                value: 'action' 
            }
        ],
        search: '',
    }),
    props: ['center'],
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.loaded = false;
            this.items = [];

            Schedules.getByCenter(this.center)
                    .then(response => {
                        if (response.status === true) {
                            this.formatItems(response.query);
                            this.loaded = true;
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                        }
                    });
            
        },
        formatItems(query) {
            query.forEach(dt => {
                let u = dt.data();
                u.id = dt.id;
                this.items.push(u);
            });

            this.items = _.orderBy(this.items, 'name', 'asc');
        }
    }
}
</script>